<template>
  <v-menu
    v-model="menu2"
    :nudge-right="40"
    transition="scale-transition"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        @click:append="menu2 = true"
        autofocus
        append-icon="fas fa-calendar-alt"
        :value="value"
        :rules="[rules]"
        :dark="dark"
        :loading="loading"
        :dense="dense"
        :disabled="disabled"
        :outlined="outlined"
        :label="label"
        v-bind="attrs"
        v-on="on"
        readonly
      >
      </v-text-field>
    </template>
    <v-date-picker :value="value" @input="UpdateValue"></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  name: "BaseDateComp",
  props: {
    rules: { type: Function, default: () => true },
    label: { type: String, default: "Date" },
    outlined: { type: Boolean, default: true },
    dark: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    value: [String],
  },
  data() {
    return {
      menu2: false,
    };
  },

  methods: {
    UpdateValue(e) {
      this.menu2 = false;
      // console.log(e);
      this.$emit("input", e);
    },
  },
  mounted() {
    // this.$emit("input", "");
  },
};
</script>
